export default __webpack_public_path__ + "static/media/triangle-exclamation.6f254560.svg";